export default [
  {
    path: "/RyCLe0gvKWeN",
    name: "invoice-create",
    meta: {
      title: "Create Invoice",
      authRequired: true,
      acc: null
    },
    component: () => import("../views/invoice/new-invoice.vue"),
  },
  {
    path: "/N01UPWsqV9bj",
    name: "invoice-list",
    meta: {
      title: "Invoices",
      authRequired: true,
      acc: ["v29", "v82"]
    },
    component: () => import("../views/invoice/invoice-list.vue"),
  },
  {
    path: "/bSG5gYzpyHEX",
    name: "invoice",
    meta: {
      title: "Invoice",
      authRequired: true,
      acc: null
    },
    component: () => import("../views/invoice/invoice.vue"),
  },
   {
    path: "/bSG5gYzpyHEXJSUYU&YGYBG",
    name: "uploadPayment",
    meta: {
      title: "upload Payments",
      authRequired: true,
      acc: null
    },
    component: () => import("../views/payments/upload.vue"),
  },
];
